module.exports = "/static/assets/68d9ddbb2aa63310b88c7697e5b0c6c9.svg";